/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Open_PlannerInputs */

const en_control_open_planner = /** @type {(inputs: Control_Open_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Build Planner`)
};

const zh_control_open_planner = /** @type {(inputs: Control_Open_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开配装规划器`)
};

/**
* | output |
* | --- |
* | "Open Build Planner" |
*
* @param {Control_Open_PlannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_open_planner = /** @type {((inputs?: Control_Open_PlannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Open_PlannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_open_planner(inputs)
	return zh_control_open_planner(inputs)
});
export { control_open_planner as "control.open_planner" }